module.exports = __webpack_public_path__ + "media/images/vehicles-topbar-d8e2cf829c7dccabf27fd4000e80d567.svg";